import teamMembers from './team-members.js';
import clients from './clients.js';

export default [...teamMembers, ...clients];
